import React, { FunctionComponent } from 'react';
import chatHamburgerIcon from 'assets/svg/chat-hamburger.svg';
import Styles from 'views/profile/landing/SettingsPhoneHeader.module.scss';

interface SettingsPhoneHeaderProps {
  title: string;
  onMenuClick: () => void;
}

/** Phone-only settings chrome — hamburger + page title (dashboard via FAB / drawer). */
const SettingsPhoneHeader: FunctionComponent<SettingsPhoneHeaderProps> = ({
  title,
  onMenuClick,
}) => (
  <header className={Styles.phoneHeader}>
    <button
      type="button"
      className={Styles.menuButton}
      onClick={onMenuClick}
      aria-label="Toggle settings menu"
    >
      <img src={chatHamburgerIcon} alt="" className={Styles.menuButtonIcon} aria-hidden="true" />
    </button>

    <h1 className={Styles.title}>{title}</h1>
  </header>
);

export default SettingsPhoneHeader;
